import React, { memo } from 'react';

const ReceiverInner = () => (
    <svg viewBox="0 0 20 15">
        <path d="M6 8C8.3 8 10 6.3 10 4C10 1.7 8.3 0 6 0C3.7 0 2 1.7 2 4C2 6.3 3.7 8 6 8ZM6 2C7.2 2 8 2.8 8 4C8 5.2 7.2 6 6 6C4.8 6 4 5.2 4 4C4 2.8 4.8 2 6 2ZM17.7426 3.75736L13.5 8L17.7426 12.2426L19.1569 10.8284L16.3284 8L19.1569 5.17157L17.7426 3.75736ZM0 14C0 11.2 2.2 9 5 9H7C9.8 9 12 11.2 12 14V15H10V14C10 12.3 8.7 11 7 11H5C3.3 11 2 12.3 2 14V15H0V14Z" />
    </svg>
);

export const Receiver = memo(ReceiverInner);
